import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { CoreHero, CoreHeroBody, CoreHeroTitle } from '@/components/ui/shared/heroes/CoreHero/CoreHero';

export const TeamHeader: FC = () => {
  const { t } = useTranslation();

  return (
    <CoreHero>
      <CoreHeroBody>
        <CoreHeroTitle>{t('team.ourTeam')}</CoreHeroTitle>
      </CoreHeroBody>
    </CoreHero>
  );
};
